import errorManager from '@/rollbar.js';

const disableMonth = (fromMonth, toMonth) => {
  const fromMonthValue = parseInt(fromMonth);
  const monthOptions = Array.from(toMonth.options);
  monthOptions.forEach((option) => {
    option.disabled = false;
    const optionValue = parseInt(option.value);
    if (optionValue < fromMonthValue || optionValue > fromMonthValue + 2) {
      option.disabled = true;
    } else {
      option.disabled = false;
    }
  });
  toMonth.innerHTML = monthOptions
    .map((option) => {
      return `<option value="${option.value}" ${option.disabled ? 'disabled' : ''}>${option.text}</option>`;
    })
    .join('');

  let newToMonthValue;
  if (fromMonthValue === 11) {
    newToMonthValue = 12;
  } else if (fromMonthValue === 12) {
    newToMonthValue = 12;
  } else {
    newToMonthValue = fromMonthValue + 2;
  }
  toMonth.value = newToMonthValue;
};

const handleDates = (fromMonthId, toMonthId) => {
  const fromMonthInput = document.querySelector(fromMonthId);
  const toMonthInput = document.querySelector(toMonthId);

  const initialFromMonth = fromMonthInput.value;
  disableMonth(initialFromMonth, toMonthInput);

  fromMonthInput.onchange = (event) => {
    const currentFromMonth = event.currentTarget.value;
    disableMonth(currentFromMonth, toMonthInput);
  };
};

const init = (fromMonthId, toMonthId) => {
  try {
    handleDates(fromMonthId, toMonthId);
  } catch (e) {
    errorManager(e);
  }
};

window.InputDatesCsvCpReport = {
  init: init,
};
